










import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { IAgency } from 'admiral-core';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';

@Component({
  components: {},
})
export default class AgencyAvatar extends mixins(BaseMixin) {
  @Prop({ required: true, type: Object })
  a!: IAgency;

  @Prop({ required: false, type: String, default: () => 'md' })
  size!: 'sm' | 'md' | 'md2' | 'lg' | 'xl';

  @Prop({ required: false, type: String })
  clazz!: string;

  @Prop({ required: false, type: String })
  status!: 'online';

  get avatarSize() {
    return this.size || 'md';
  }
}
